import dayjs from "dayjs";

export default (date: any) => dayjs(date).format("YYYY-MM-DD");